import * as crypto from 'crypto-js';

// Encriptar / desencriptar.
export function manageAES(value: string, type: string): any {
  const key = 'HecnlsndSQ100495';
  const keyHex = crypto.enc.Utf8.parse(key);

  if (type === 'encrypt') {
    return crypto.AES.encrypt(value, keyHex, { mode: crypto.mode.ECB });
  } else {
    return crypto.AES.decrypt(value, keyHex, {
      mode: crypto.mode.ECB,
    }).toString(crypto.enc.Utf8);
  }
}

// Obtener API.
export function obtainApi(apiService: any, url: any, toasterService: any): Promise<any> {
  return new Promise((resolve, reject) => {
    apiService.getApi(url).subscribe((api: any) => {
      if (api && api['message']) {
        toasterService.new('error', 'ERROR', api['message']);
      } else {
        resolve(api);
      }
    });
  });
}

// Obtener token.
export function getToken(api: any, storageService: any): any {
  if (storageService.retrieve(api)) {
    const token = JSON.parse(storageService.retrieve(api));
    if (token) {
      const dateExpired = token.expires;
      const nowDate = new Date().getTime();
      if (new Date(nowDate) < new Date(dateExpired)) {
        return token;
      } else {
        token['token']['isExpired'] = true;
        return token;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}

// Guardar token en localStorage.
export function setToken(api: any, token: any, storageService: any): void {
  if (api && token) {
    const objeto: any = {};
    const dateExpires = new Date().getTime() + token['expires_in'] * 1000 - 30 * 1000;
    objeto['token'] = token;
    objeto['expires'] = dateExpires;
    storageService.store(api, JSON.stringify(objeto));
  }
}

export function obtainTokenAndCompanyParams(api: any, storage: any, serverService: any, toastService: any, apiServerService: any, url: any, serverCode: any): Promise<any> {
  return new Promise((resolve, reject) => {
    const token = getToken(api['description'], storage);
    if (!token) {
      serverService.getServersByDmsCode(url, serverCode).subscribe((result: any) => {
        if (result && result['message']) {
          toastService.new('error', 'ERROR', result['message']);
        } else if (result && result['length'] && result['length'] > 0) {
          const serverParams = result[0];
          apiServerService.getApiServersByDmsCodeId(url, serverParams['_id'], api['_id']).subscribe((apiServer: any) => {
            if (apiServer && apiServer['message']) {
              toastService.new('error', 'ERROR', result['message']);
            } else {
              const callback = {
                token: token,
                companyParams: apiServer,
              };
              resolve(callback);
            }
          });
        }
      });
    } else {
      const callback = {
        token: token,
        companyParams: token['token'],
      };
      resolve(callback);
    }
  });
}

// Get API params (QSigner + QWebPrinter)
export function obtainTokenAndCompanyParamsSigner(api: any, storage: any, serverService: any, toastService: any, apiServerService: any, url: any, serverCode: any): Promise<any> {
  return new Promise((resolve, reject) => {
    const token = getToken(api['description'], storage);
    // Get server by qawid
    serverService.getServersByDmsCode(url, serverCode).subscribe((result: any) => {
      if (result && result['message']) {
        toastService.new('error', 'ERROR', result['message']);
      } else if (result && result['length'] && result['length'] > 0) {
        // No token, full process
        if (!token) {
          const serverParams = result[0];
          apiServerService.getApiServersByDmsCodeId(url, serverParams['_id'], api['_id']).subscribe((apiServer: any) => {
            if (apiServer && apiServer['message']) {
              toastService.new('error', 'ERROR', result['message']);
            } else {
              const callback = {
                token: token,
                companyParams: apiServer,
              };
              resolve(callback);
            }
          });
        } else {
          // Has token
          // Check if token is for current server
          if (result[0]['_id'] !== token['token']['server']) {
            const serverParams = result[0];
            apiServerService.getApiServersByDmsCodeId(url, serverParams['_id'], api['_id']).subscribe((apiServer: any) => {
              if (apiServer && apiServer['message']) {
                toastService.new('error', 'ERROR', result['message']);
              } else {
                const callback = {
                  token: token,
                  companyParams: apiServer,
                };
                resolve(callback);
              }
            });
          } else {
            const callback = {
              token: token,
              companyParams: token['token'],
            };
            resolve(callback);
          }
        }
      } else {
        // No result, no client
        resolve('NO_CLIENT');
      }
    });
  });
}

// Scroll hacia arriba
export function scrollToTop(): void {
  const scrollToTop = window.setInterval(function () {
    const pos = window.pageYOffset;
    if (pos > 0) {
      window.scrollTo(0, pos - 20);
    } else {
      window.clearInterval(scrollToTop);
    }
  }, 16);
}

// Scroll hacia abajo
export function scrollToDown(): void {
  setTimeout(() => {
    var pos = document.body.scrollHeight;
    if (pos > 0) {
      window.scrollTo({
        top: pos,
        left: 100,
        behavior: 'smooth',
      });
    }
  }, 600);
}

/* showToaster(this.toastService, 'succes/warning/error', this.translateService, 'TRANSLATION_TITLE', 'TRANSLATION_MESSAGE', 'Text without translation') */
export function showToaster(toaster: any, type: string, translate: any, titleToTranslate: string, messageToTranslate: string, optionalText?: string, toasterConfiguration?: any) {
  // Title and message (with translation)
  let title = new Promise((resolve, reject) => {
    if (titleToTranslate) {
      translate.get(titleToTranslate).subscribe((result: any) => {
        resolve(result);
      });
    } else {
      resolve('');
    }
  });

  let message = new Promise((resolve, reject) => {
    if (messageToTranslate) {
      translate.get(messageToTranslate).subscribe((result: any) => {
        resolve(result);
      });
    } else {
      resolve('');
    }
  });

  Promise.all([title, message])
    .then((val: any) => {
      switch (type) {
        case 'success':
          if (!optionalText && !toasterConfiguration) {
            toaster.new('success', val[0].toString(), val[1].toString());
          } else if (optionalText && !toasterConfiguration) {
            toaster.new('success', val[0].toString(), val[1].toString() + ': ' + optionalText);
          } else if (!optionalText && toasterConfiguration) {
            toaster.new('success', val[0].toString(), val[1].toString(), toasterConfiguration);
          } else {
            toaster.new('success', val[0].toString(), val[1].toString() + ': ' + optionalText, toasterConfiguration);
          }
          break;
        case 'warning':
          if (!optionalText && !toasterConfiguration) {
            toaster.new('warning', val[0].toString(), val[1].toString());
          } else if (optionalText && !toasterConfiguration) {
            toaster.new('warning', val[0].toString(), val[1].toString() + ': ' + optionalText);
          } else if (!optionalText && toasterConfiguration) {
            toaster.new('warning', val[0].toString(), val[1].toString(), toasterConfiguration);
          } else {
            toaster.new('warning', val[0].toString(), val[1].toString() + ': ' + optionalText, toasterConfiguration);
          }
          break;
        case 'error':
          if (!optionalText && !toasterConfiguration) {
            toaster.new('error', val[0].toString(), val[1].toString());
          } else if (optionalText && !toasterConfiguration) {
            toaster.new('error', val[0].toString(), val[1].toString() + ': ' + optionalText);
          } else if (!optionalText && toasterConfiguration) {
            toaster.new('error', val[0].toString(), val[1].toString(), toasterConfiguration);
          } else {
            toaster.new('error', val[0].toString(), val[1].toString() + ': ' + optionalText, toasterConfiguration);
          }
          break;
        case 'info':
          if (!optionalText && !toasterConfiguration) {
            toaster.new('info', val[0].toString(), val[1].toString());
          } else if (optionalText && !toasterConfiguration) {
            toaster.new('info', val[0].toString(), val[1].toString() + ': ' + optionalText);
          } else if (!optionalText && toasterConfiguration) {
            toaster.new('info', val[0].toString(), val[1].toString(), toasterConfiguration);
          } else {
            toaster.new('info', val[0].toString(), val[1].toString() + ': ' + optionalText, toasterConfiguration);
          }
          break;
      }
    })
    .catch((err) => {
      toaster.new('error', translate.get('LOGIN.TOAST_ERROR')['value'], translate.get('LOGIN.TOAST_ERROR')['value']);
    });
}

export function comprobarNativo() {
  const oWebViewInterface = window['nsWebViewInterface'];
  return new Promise((resolve, reject) => {
    oWebViewInterface.on('enviarTipoDispositivo', function (dispositivo: any) {
      if (dispositivo === true) {
        oWebViewInterface.emit('tipodispositivo', dispositivo);
        resolve(dispositivo);
      } else {
        resolve(dispositivo);
      }
    });
  });
}
